import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import {
  FooterSection,
  Para,
  FooterContainer,
  Language,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const currentYear = new Date().getFullYear();

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="36px" height="36px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="start" align="top">
            <Col lg={12} md={12} sm={12} xs={24} style={{ textAlign: 'center' }}>
              <Language>{t("Contact")}</Language>
              <FooterContainer>
                <SocialLink
                  href="https://www.instagram.com/centrodelinguaalemabh/?hl=pt"
                  src="instagram.svg"
                />
                <SocialLink
                  href="https://wa.me/5531982720559"
                  src="whatsapp.svg"
                />
              </FooterContainer>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24} style={{ textAlign: 'center' }}>
              <Para>© {currentYear} {t("copyright")}</Para>
            </Col>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
